import React, { useRef, useEffect } from 'react';

interface RichTextEditorProps {
  content: string;
  onChange: (content: string) => void;
  placeholder?: string;
}

const RichTextEditor: React.FC<RichTextEditorProps> = ({ content, onChange, placeholder }) => {
  const editorRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (editorRef.current && editorRef.current.innerHTML !== content) {
      editorRef.current.innerHTML = content;
    }
  }, [content]);

  const handleInput = () => {
    if (editorRef.current) {
      onChange(editorRef.current.innerHTML);
    }
  };

  const execCommand = (command: string, value?: string) => {
    document.execCommand(command, false, value);
    handleInput();
  };

  return (
    <div className="rich-text-editor" style={{ marginBottom: '1rem' }}>
      <div className="editor-toolbar" style={{ 
        display: 'flex', 
        gap: '0.5rem', 
        marginBottom: '0.5rem', 
        padding: '0.5rem', 
        backgroundColor: 'rgba(0,0,0,0.2)', 
        border: '1px solid var(--accent-purple)',
        borderRadius: '4px'
      }}>
        <button type="button" onClick={() => execCommand('bold')} title="Bold"><strong>B</strong></button>
        <button type="button" onClick={() => execCommand('italic')} title="Italic"><em>I</em></button>
        <button type="button" onClick={() => execCommand('underline')} title="Underline"><u>U</u></button>
        <button type="button" onClick={() => execCommand('insertUnorderedList')} title="Bullet List">• List</button>
        <button type="button" onClick={() => execCommand('insertOrderedList')} title="Numbered List">1. List</button>
        <button type="button" onClick={() => execCommand('formatBlock', 'h3')} title="Heading">H</button>
      </div>
      <div
        ref={editorRef}
        contentEditable
        onInput={handleInput}
        style={{
          minHeight: '200px',
          padding: '1rem',
          border: '1px solid var(--accent-purple)',
          borderRadius: '4px',
          backgroundColor: 'rgba(255, 255, 255, 0.05)',
          color: 'var(--pale-gold)',
          outline: 'none',
          lineHeight: '1.6'
        }}
        data-placeholder={placeholder}
      />
    </div>
  );
};

export default RichTextEditor;
